import { motion, useMotionValue, useSpring } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { ROOBET_URL } from "@/lib/site";

export const PlayButton = ({ testId, size = "md", className = "" }) => {
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, { stiffness: 220, damping: 15 });
  const sy = useSpring(y, { stiffness: 220, damping: 15 });
  const big = size === "lg";

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    x.set((e.clientX - r.left - r.width / 2) * 0.25);
    y.set((e.clientY - r.top - r.height / 2) * 0.35);
  };

  return (
    <motion.a
      href={ROOBET_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testId}
      onMouseMove={onMove}
      onMouseLeave={() => { x.set(0); y.set(0); }}
      style={{ x: sx, y: sy }}
      whileTap={{ scale: 0.96 }}
      className={`play-btn group ${big ? "px-8 py-5 text-base sm:text-lg" : "px-5 py-3 text-sm"} ${className}`}
    >
      <img src="/assets/roobet-icon.png" alt="" className={`${big ? "h-7 w-7" : "h-5 w-5"} play-btn-icon`} />
      <span>Play on Roobet</span>
      <ArrowUpRight className={`${big ? "h-5 w-5" : "h-4 w-4"} transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5`} />
    </motion.a>
  );
};
